import DefaultPageLayout from "@/layouts/DefaultPageLayout";
import { Divider, Skeleton } from "@nextui-org/react";
import clsx from "clsx";
function ActivityLoading() {
  return <DefaultPageLayout data-sentry-element="DefaultPageLayout" data-sentry-component="ActivityLoading" data-sentry-source-file="ActivityLoading.tsx">
            <div className="flex flex-col gap-5">
                <div className="flex flex-col gap-3">
                    <Skeleton className="w-20 h-7 bg-default/10 before:opacity-20 rounded" data-sentry-element="Skeleton" data-sentry-source-file="ActivityLoading.tsx" />
                    <div className="flex flex-col gap-2.5">
                        <div className="flex items-center gap-2">
                            <Skeleton className="w-24 h-5 bg-default/10 before:opacity-20 rounded" data-sentry-element="Skeleton" data-sentry-source-file="ActivityLoading.tsx" />
                            <Divider orientation="vertical" className="w-2 h-0.5 bg-default/10 before:opacity-20 rounded" data-sentry-element="Divider" data-sentry-source-file="ActivityLoading.tsx" />
                            <Skeleton className="w-24 h-5 bg-default/10 before:opacity-20 rounded" data-sentry-element="Skeleton" data-sentry-source-file="ActivityLoading.tsx" />
                        </div>
                        <div className="flex items-center justify-between gap-20">
                            <Skeleton className="flex-1 h-7 bg-default/10 before:opacity-20 rounded" data-sentry-element="Skeleton" data-sentry-source-file="ActivityLoading.tsx" />
                            <Skeleton className="size-7 bg-default/10 before:opacity-20 rounded" data-sentry-element="Skeleton" data-sentry-source-file="ActivityLoading.tsx" />
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <Skeleton className="w-12 h-3 bg-default/10 before:opacity-20 rounded" data-sentry-element="Skeleton" data-sentry-source-file="ActivityLoading.tsx" />
                    {Array(2).fill(4).map((_, i) => {
          const width = Math.floor(Math.random() * (66 - 33 + 1)) + 33;
          const widthDesc = Math.floor(Math.random() * (66 - 33 + 1)) + 33;
          return <div className={clsx("bg-gradient-to-r from-[rgba(255,255,255,0.16)] to-[rgba(255,255,255,0)] rounded-2xl")} key={i}>
                                    <div className="p-3 flex items-center justify-between">
                                        <div className="flex-1 flex items-center gap-3 duration-0">
                                            <Skeleton className="size-9 rounded-full bg-default/10 before:opacity-20" />
                                            <div className="flex flex-col gap-1 flex-1">
                                                <Skeleton className="w-24 h-4 bg-default/10 before:opacity-20 rounded" style={{
                    width: `${width}%`
                  }} />
                                                <Skeleton className="w-24 h-3 bg-default/10 before:opacity-20 rounded" style={{
                    width: `${widthDesc}%`
                  }} />
                                            </div>
                                        </div>
                                        <Skeleton className="w-10 h-4 bg-default/10 before:opacity-20 rounded" />
                                    </div>
                                </div>;
        })}
                </div>
                <div className="flex flex-col gap-2">
                    <Skeleton className="w-12 h-3 bg-default/10 before:opacity-20 rounded" data-sentry-element="Skeleton" data-sentry-source-file="ActivityLoading.tsx" />
                    {Array(3).fill(4).map((_, i) => {
          const width = Math.floor(Math.random() * (66 - 33 + 1)) + 33;
          const widthDesc = Math.floor(Math.random() * (66 - 33 + 1)) + 33;
          return <div className={clsx("bg-gradient-to-r from-[rgba(255,255,255,0.16)] to-[rgba(255,255,255,0)] rounded-2xl")} key={i}>
                                    <div className="p-3 flex items-center justify-between">
                                        <div className="flex-1 flex items-center gap-3">
                                            <Skeleton className="size-9 rounded-full bg-default/10 before:opacity-20" />
                                            <div className="flex flex-col gap-1 flex-1">
                                                <Skeleton className="w-24 h-4 bg-default/10 before:opacity-20 rounded" style={{
                    width: `${width}%`
                  }} />
                                                <Skeleton className="w-24 h-3 bg-default/10 before:opacity-20 rounded" style={{
                    width: `${widthDesc}%`
                  }} />
                                            </div>
                                        </div>
                                        <Skeleton className="w-10 h-4 bg-default/10 before:opacity-20 rounded" />
                                    </div>
                                </div>;
        })}
                </div>
                <div className="flex items-center justify-center gap-1">
                    {Array(5).fill(4).map((_, i) => <Skeleton className="size-9 bg-default/10 before:opacity-20 rounded-full" key={i} />)}
                </div>
            </div>
        </DefaultPageLayout>;
}
export default ActivityLoading;